module.exports = __webpack_public_path__ + "img/1.8ed696ba.png";